import React from "react";
import { Link } from "react-router-dom";
import { all_routes } from "../../router/all_routes";
import CommonSelect from "../../../core/common/commonSelect";
import { status } from "../../../core/common/selectoption/selectoption";
import CollapseHeader from "../../../core/common/collapse-header/collapse-header";

const GlobalSettings = () => {
  const routes = all_routes;

  return (
    <div>
      <div className="page-wrapper">
        <div className="content">
          <div className="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
            <div className="my-auto mb-2">
              <h2 className="mb-1">Global Settings</h2>
              <nav>
                <ol className="breadcrumb mb-0">
                  <li className="breadcrumb-item">
                    <Link to={routes.adminDashboard}>
                      <i className="ti ti-smart-home" />
                    </Link>
                  </li>
                  <li className="breadcrumb-item">Settings</li>
                  <li className="breadcrumb-item active">Global Settings</li>
                </ol>
              </nav>
            </div>
            <div className="head-icons ms-2">
              <CollapseHeader />
            </div>
          </div>

          <div className="row">
            <div className="col-xl-12">
              <div className="card">
                <div className="card-body">
                  <div className="border-bottom mb-3 pb-3">
                    <h4>Global Settings Configuration</h4>
                  </div>
                  <form>
                    <div className="row">
                      <div className="col-md-6">
                        <div className="mb-3">
                          <label className="form-label">Site Name</label>
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Enter site name"
                          />
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="mb-3">
                          <label className="form-label">Site URL</label>
                          <input
                            type="url"
                            className="form-control"
                            placeholder="Enter site URL"
                          />
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="mb-3">
                          <label className="form-label">Site Language</label>
                          <CommonSelect
                            className="select"
                            options={[
                              { value: "en", label: "English" },
                              { value: "hi", label: "Hindi" },
                            ]}
                          />
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="mb-3">
                          <label className="form-label">Time Zone</label>
                          <CommonSelect
                            className="select"
                            options={[
                              { value: "UTC", label: "UTC" },
                              { value: "GMT", label: "GMT" },
                              { value: "IST", label: "IST" },
                            ]}
                          />
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="mb-3">
                          <label className="form-label">Site Status</label>
                          <CommonSelect className="select" options={status} />
                        </div>
                      </div>
                    </div>

                    <div className="d-flex align-items-center justify-content-end">
                      <button
                        type="button"
                        className="btn btn-outline-light border me-3"
                      >
                        Reset
                      </button>
                      <button type="submit" className="btn btn-primary">
                        Save Changes
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="footer d-sm-flex align-items-center justify-content-between border-top bg-white p-3">
          <p className="mb-0">2024 © DMRC Admin Panel</p>
          <p className="mb-0">
            Powered by{" "}
            <Link to="#" className="text-primary">
              DMRC
            </Link>
          </p>
        </div>
      </div>
    </div>
  );
};

export default GlobalSettings;
